import { t } from "i18n-js";
import basicRequest, { POST_REQUEST, PUT_REQUEST } from "../../../../core/redux/actions/request";

import { notification } from "antd";

const PREFIX = "VENDOR_JOB_SHOW";
const getState = (state) => state.vendor.job.show;

const {
    getPattern,

    actionPostPattern,
    actionPutPattern,
    actionDeletePattern,

    requestPattern,

    error,
    loading,
    success,
    reset,
    secondaryError,
    secondaryLoading,
    isSecondaryLoading,
    secondarySuccess,
    secondaryReset: formReset,

    isLoaded,
    isLoading,
    getError,
    getData,

    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,
} = basicRequest(PREFIX, getState);

export const load = (id) => getPattern("vendor/jobs/v2/" + id, {}, null);

export { reset, isLoading, isLoaded, getError, getData, getFormSuccess, getFormError, formReset, isSecondaryLoading };

export const acceptTask = (id, taskId, form) =>
    actionPutPattern("vendor/jobs/v2/" + id + "/tasks/" + taskId + "/accept", form, {
        message: "Update",
        description: "The Task was accepted",
    });

export const rejectTask = (id, taskId, form) =>
    actionPutPattern("vendor/jobs/v2/" + id + "/tasks/" + taskId + "/reject", form, {
        message: "Update",
        description: "The Task was rejected",
    });

export const negotiateTask = (id, taskId, form) =>
    actionPutPattern("vendor/jobs/v2/" + id + "/tasks/" + taskId + "/negotiate", form, {
        message: "Update",
        description: "The Task was updated",
    });

export const completeTask = (id, taskId, form) =>
    actionPutPattern("vendor/jobs/v2/" + id + "/tasks/" + taskId + "/complete", form, {
        message: "Update",
        description: "The Task was updated",
    });
